export default __webpack_public_path__ + "static/media/green2.984e26b8.png";